// extracted by mini-css-extract-plugin
var _1 = "TemplatesList_root__b11f6";
export { _1 as "root" }
